define(['jQuery'],
    function($) {
        var fallbackLocale = "de";

        var Url = function (href) {
            if (href === undefined) {
                href = window.location.href;
            }
            
            // Do not use prototype's objects, they're copyed by reference
            // (a shallow copy) -- AG.
            this.query = { };
            this.hash = { };

            var indexOfProtocol = href.indexOf("://");
            if (indexOfProtocol >= 0) {
                this.protocol = href.substring(0, indexOfProtocol);
                href = href.substring(indexOfProtocol + 3);
                
                var indexOfSlash = href.indexOf("/");
                this.domain = href.substring(0, indexOfSlash);
                href = href.substring(indexOfSlash);
            }
            
            var indexOfHash = href.indexOf("#");
            var indexOfQuestion = href.indexOf("?");
            
            if (indexOfHash >= 0 && indexOfQuestion >= 0 && indexOfHash < indexOfQuestion) {
                throw new Error("# sign should be somewhere after ? in a valid URL.");
            }
            
            if (indexOfHash >= 0) {
                //this.hash = Url.parseQuery(href.substring(indexOfHash + 1));
                this.hash = href.substring(indexOfHash + 1);
                href = href.substring(0, indexOfHash);
            }
            if (indexOfQuestion >= 0) {
                this.query = Url.parseQuery(href.substring(indexOfQuestion + 1));
                href = href.substring(0, indexOfQuestion);
            }

            this.path = href;
        };
        
        Url.decode = function (encoded) {
            return decodeURIComponent(encoded.replace(/\+/g, "%20"));
        };
        Url.encode = function (decoded) {
            return encodeURIComponent(decoded.replace(/%20/g, "+"));
        };
        
        Url.parseQuery = function (queryString) {
            var items = queryString.split("&");
            
            var result = { };
            if (queryString.length > 0) {
                // This condition is needed for handling URLs like http://abc.com#
                // Notice an empty hash at the end -- AG.
                for (var i = 0; i < items.length; i++) {
                    var pair = items[i].split("=");
                    var key = Url.decode(pair[0]);
                    var value = '';
                    if(pair.length >= 2) {
                        value = Url.decode(pair[1]);
                    }
                    result[key] = value;
                }
            }
            return result;
        };
        
        Url.prototype = {
            protocol: null,
            domain: null,
            path: null,
            query: { },
            hash: { },
            getLocale: function () {
                // Get global locale (Recommended way)
                // You need to define var locale in HTML document
                if (typeof locale !== 'undefined') {
                    return locale;
                }

                throw new Error('Locale is not defined!');
                // DEPRECATED: Determine locale from URL
                // var match;
                // return (match = this.path.match(/\/{1}([a-z]{2}(_[a-z]{2})?)\//)) && match[1] || fallbackLocale;
            },
            setLocale: function (locale) {
                if (typeof locale == "string" && locale.length == 2) {
                    this.path = this.path.replace(/(.+\/{1})([a-z]{2})(\/.+)/, "$1" + locale + "$3");
                } else {
                    throw new Error("Locale is malformed. String {2} is expected.");
                }
            },
            getCurrency: function () {
                return this.query.currency;
            },
            setCurrency: function (value) {
                if (value != null) {
                    this.query.currency = value;
                } else {
                    delete this.query.currency;
                }
            },
            withoutDomain: function () {
                var result = $.extend(true, {}, this);
                result.protocol = null;
                result.domain = null;
                
                return result;
            },
            getQuery: function() {
                if (!$.isEmptyObject(this.query)) {
                    return "?" + $.param(this.query);
                } else {
                    return "";
                }
            },
            getHash: function() {
                if (!$.isEmptyObject(this.hash)) {
                    return "#" + $.param(this.hash);
                } else {
                    return "";
                }
            },
            toString: function () {
                var result = "";
                if (this.protocol !== null) {
                    result += this.protocol + "://";
                }
                if (this.domain !== null) {
                    result += this.domain;
                }
                if (this.path != null) {
                    result += this.path;
                }
                result += this.getQuery();
                result += this.getHash();
                
                return result;
            }
        };
        
        return Url;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-util/url.js
// module id = 14
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23